import api from './client';
import ApiError from './error';

const CategoryService = {
  async searchCategories({ params }) {
    try {
      const client = await api.getClient();
      return client.searchCategories(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getCategory({ id }) {
    try {
      const client = await api.getClient();
      return client.viewCategory(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createCategory({ category }) {
    try {
      const client = await api.getClient();
      return client.createCategory(null, category);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateCategory({ id, category }) {
    try {
      const client = await api.getClient();

      client.interceptors.response.use((response) => response, (error) => {
        // Redirect after update
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateCategory(id, category);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteCategory({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteCategory(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

};

export default CategoryService;
